import { Link } from "react-router-dom";
import styles from "./styles.module.css";

const ExitButton = () => {
  return (
    <Link className={styles.exitButton} to="/logout">
      <span>Sair</span>
    </Link>
  );
};

export default ExitButton;
